var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.ALLERGY_TYPE = {
    OTHER: 'OTHER',
    FOOD: 'FOOD',
    DRUGS: 'DRUGS',
    POLLEN: 'POLLEN',
    PATIENT_CLAIMS_NO_ALLERGIES: 'PATIENT_CLAIMS_NO_ALLERGIES'
};

Object.freeze(Enum.MEEDY.ALLERGY_TYPE);